import { CurrentUser } from "../../model/CurrentUser";

const IF = require( "infrontjs" );

import template from './RequestPasswordResetTemplate.html';
import { IndexState } from "../index/IndexState";

export class RequestPasswordResetState extends IF.State
{
    static ROUTE = '/request-password-reset';
    static ID = 'requestPasswordReset';

    canEnter()
    {
        return ( this.app.currentUser === null );
    }

    getRedirectUrl()
    {
        return IndexState.ROUTE;
    }

    async enter()
    {
        this.app.container.innerHTML = template;

        this.app.container.querySelector( '[data-id="btnRequestPasswordReset"]' ).addEventListener( 'click', async ( btn ) => {
            const errContainer = this.app.container.querySelector( '[data-id="error-container"]' );
            errContainer.classList.add( 'hidden' );
            const form = this.app.container.querySelector( 'form[data-id="password-reset-request-form"]' );
            form.classList.add( 'validated' );
            if ( true === form.checkValidity() )
            {
                this.app.gui.showLoader();

                const formData = IF.Helper.serializeForm( form );
                let response = null;
                try
                {
                    response = await this.app.api.post( '/auth/request-password-reset', formData );
                }
                catch( e )
                {
                    response = null;
                }

                let errMsg = 'Ein Fehler ist aufgetreten. Bitte versuche es zu einem späteren Zeitpunkt erneut';
                if ( response )
                {
                    switch ( response.status )
                    {
                        case 201:
                            errMsg = null;
                            this.app.container.querySelector( '[data-id="form"]' ).classList.add( 'hidden' );
                            this.app.container.querySelector( '[data-id="form-success"]' ).classList.remove( 'hidden' );
                        break;

                        case 400:
                            errMsg = 'Es wurde kein Benutzer gefunden.';
                        break;
                    }
                }
                if ( null !== errMsg )
                {
                    errContainer.querySelector( '[data-id="error-text"]' ).innerHTML = errMsg;
                    errContainer.classList.remove( 'hidden' );
                }

                this.app.gui.hideLoader();
            }
        });
    }

    async exit()
    {
        this.app.container.querySelector( '[data-id="btnRequestPasswordReset"]' ).removeEventListeners( 'click' );
    }
};
